import apiRequest from './client';

// Dashboard CGL (superadmin). date optionnelle (YYYY-MM-DD), defaut = aujourd'hui (Port-au-Prince).
export const fetchDashboardOverview = ({ date } = {}) =>
  apiRequest(`/dashboard/overview/${date ? `?date=${encodeURIComponent(date)}` : ''}`);

// Dashboard company — memes indicateurs, limites a la company connectee.
export const fetchCompanyDashboard = ({ date } = {}) =>
  apiRequest(`/dashboard/company-overview/${date ? `?date=${encodeURIComponent(date)}` : ''}`);
